module.exports = __webpack_public_path__ + "static/ProdRight_3-36e93936f1929677ce8885edf2f2e1a0.png";